<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-select
        :items="items"
        :label="label"
        return-object
        item-text="cela_adresa"
        v-model="item"
        :hide-details="hideDetails"
        :outline="outline"
        class="mx-2"
        :rules="rules"
        :disabled="disabled"
      ></v-select>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  data: function () {
    return {
      items: [],
      item: null
    }
  },
  props: {
    hideDetails: Boolean,
    outline: Boolean,
    rules: Array,
    value: Object,
    all: Boolean,
    disabled: Boolean,
    label: String,
    client: String,
    fakturacni: Boolean,
    dorucovaci: Boolean,
    selectFirst: Boolean
  },
  watch: {
    item (v) {
      this.$emit("changed", v);
      this.$emit("input", v);
    }
  },
  mounted: function() {
    this.load();
  },
  methods: {
    load: function(v) {
      window.api.post("osoby/"+this.$props.client+"/adresy/search", {
        fakturacni: this.fakturacni,
        dorucovaci: this.dorucovaci
      }).then(function(_body) {
        this.items = _body;
        if (this.$props.selectFirst && this.items.length > 0)
          this.item = this.items[0];
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    }
  },
  components: {

  }
}
</script>
<style scoped>
.v-select__selection-text {
  max-width: 100px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Adresa.vue